export const MIS_DATA_LOG_CREATE = "MIS_DATA_LOG_CREATE";
export const MIS_DATA_LOG_CREATE_SUCCESS = "MIS_DATA_LOG_CREATE_SUCCESS";
export const MIS_DATA_LOG_CREATE_FAIL = "MIS_DATA_LOG_CREATE_FAIL";

export const GET_MIS_DATA_LOG_DETAILS = "GET_MIS_DATA_LOG_DETAILS";
export const GET_MIS_DATA_LOG_DETAILS_SUCCESS = "GET_MIS_DATA_LOG_DETAILS_SUCCESS";
export const GET_MIS_DATA_LOG_DETAILS_FAIL = "GET_MIS_DATA_LOG_DETAILS_FAIL";

export const UPDATE_MIS_DATA_LOG = "UPDATE_MIS_DATA_LOG";
export const UPDATE_MIS_DATA_LOG_SUCCESS = "UPDATE_MIS_DATA_LOG_SUCCESS";
export const UPDATE_MIS_DATA_LOG_FAIL = "UPDATE_MIS_DATA_LOG_FAIL";

export const DELETE_MIS_DATA_LOG = "DELETE_MIS_DATA_LOG";
export const DELETE_MIS_DATA_LOG_SUCCESS = "DELETE_MIS_DATA_LOG_SUCCESS";
export const DELETE_MIS_DATA_LOG_FAIL = "DELETE_MIS_DATA_LOG_FAIL";

export const RESET = "RESET";
export const RESET_MIS_DATA_LOG_CREATE = "RESET_MIS_DATA_LOG_CREATE";
export const RESET_MIS_DATA_LOG_DETAILS = "RESET_MIS_DATA_LOG_DETAILS";